<template>
  <div class="page-head">
    <h1>{{ t("Parcours", "Experience") }}</h1>
    <p class="lead">
      {{
        t(
          "Du premier stage en 2019 à aujourd'hui : du fullstack, des produits fintech, et une communauté co-fondée en chemin.",
          "From my first internship in 2019 to today: fullstack work, fintech products, and a community co-founded along the way."
        )
      }}
    </p>
  </div>
  <section class="sec">
    <ul class="timeline">
      <li v-for="(x, i) in experiences" :key="i" :class="{ cur: x.current }">
        <CompanyLogo :src="x.logo" :photo="x.photo" :position="x.position" :initials="x.initials" />
        <div>
          <div class="row">
            <h3>{{ x.name }}</h3>
            <time>{{ t(x.dates) }}</time>
          </div>
          <div class="role">{{ t(x.role) }}<template v-if="x.where"> · {{ x.where }}</template></div>
          <p>{{ t(x.text) }}</p>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <ul v-if="x.points" class="points"><li v-for="(pt, j) in x.points" :key="j" v-html="t(pt)"></li></ul>
        </div>
      </li>
    </ul>
    <p>
      <a class="link" href="https://www.linkedin.com/in/arolle-fona-300705188/" target="_blank" rel="noopener">
        {{ t("Voir mon profil LinkedIn", "See my LinkedIn profile") }} <ArrowUpRight />
      </a>
    </p>
  </section>
</template>

<script>
import { ArrowUpRight } from "lucide-vue-next";
import CompanyLogo from "@/components/Logo.vue";
import { EXPERIENCES } from "@/content";
import { useI18n } from "@/i18n";

export default {
  name: "ExperiencePage",
  components: { ArrowUpRight, CompanyLogo },
  setup: () => ({ ...useI18n(), experiences: EXPERIENCES }),
};
</script>

<style scoped>
.points {
  margin-top: 10px;
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.points li {
  position: relative;
  padding-left: 18px;
  font-size: 15px;
  color: var(--ink-2);
}
.points li::before {
  content: "";
  position: absolute;
  left: 2px;
  top: 0.7em;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--pink-bright);
}
.points :deep(b) {
  color: var(--ink);
}
</style>
